export enum CharacterStatus {
    active = 'active',
    inactive = 'inactive',
    ineligible = 'ineligible'
}
